import useProfiler from "../../../hooks/useProfiler";
import { createMicroConversionTrackingUtils } from "..";
import { useCallback, useMemo } from "react";
import useRouteName from "../../../hooks/useRouteName";
import { useSelector } from "react-redux";
import { getSearchResultsFlightOffers } from "../../../store/searchResults/selectors";
import useOfferCartOrderData from "../../../hooks/useOfferCartOrderData";

const utils = createMicroConversionTrackingUtils({
  name: "flights_web_2_step_ranker",
  stages: {
    sr: 1,
    meta: 2,
    direct: 3,
    desktop: 4,
    mobile: 5,
    solo: 6,
    nonsolo: 7,
    genius: 8
  },
  defaultStage: 1,
  mainStage: 1,
  goals: {
    clickedOnTopFiveOffers: 1,
    checkAndPayForTopFiveOffers: 2
  },
  goalsWithValue: []
});

export default function useTrackFlightsWeb2StepRanker() {
  const routename = useRouteName();
  const offerCartOrderData = useOfferCartOrderData();
  const offers = useSelector(getSearchResultsFlightOffers);
  const { isDirect, isAmerican, isSolo, isDesktop, isGenius } = useProfiler();

  const trackStages = useCallback(() => {
    if (routename !== "searchresults") return;
    if (!offers?.length) return;
    if (isAmerican()) return;
    utils.stages.sr();
    isDirect() ? utils.stages.direct() : utils.stages.meta();
    isSolo() ? utils.stages.solo() : utils.stages.nonsolo();
    isDesktop() ? utils.stages.desktop() : utils.stages.mobile();
    isGenius() ? utils.stages.genius() : utils.stages.sr();
  }, [routename, isAmerican, isDesktop, isDirect, isGenius, isSolo, offers]);

  const trackGoals = useCallback(
    (token: string) => {
      const { isInTopFiveOffers } = offerCartOrderData.get(token);
      if (!isInTopFiveOffers) return;
      utils.goals.checkAndPayForTopFiveOffers();
    },
    [offerCartOrderData]
  );

  const top5 = useMemo(() => {
    return offers?.slice(0, 5).map((o) => o.token) || [];
  }, [offers]);

  const onClick = useCallback(
    (token: string) => {
      const isTop5 = top5.includes(token);
      if (!isTop5) return;
      utils.goals.clickedOnTopFiveOffers();
      offerCartOrderData.set(token, { isInTopFiveOffers: true });
    },
    [top5, offerCartOrderData]
  );

  return { onClick, trackGoals, trackStages };
}
